import React, { Component } from "react";
import { l } from "../functions";
import Icon from "./Icons";
import axios from "axios";
import { ajaxUri } from "../consts";
import GKEvent from "../events";
import { connect } from "react-redux";
import { Select } from "./FormElements";
import ColorSetter from "./NewColorPicker";
import Switch from "@material-ui/core/Switch";
import ImageUploader from "./ImageUploader";

const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

const tempHeader = [
  {
    label: l("header10"),
    value: 14,
    vbLabel: l("header 13"),
  },
  {
    label: l("header3"),
    value: 15,
    vbLabel: l("header 13"),
  },
  {
    label: l("header5"),
    value: 16,
    vbLabel: l("header 13"),
  },
  {
    label: l("dropship"),
    value: 17,
    vbLabel: l("header 13"),
  },
  {
    label: l("groovezone"),
    value: 18,
    vbLabel: l("header 13"),
  },
];

const headerLabelMap = [
  {
    label: l("default"),
    value: 1,
    vbLabel: l("default"),
  },
  {
    label: l("header9"),
    value: 2,
    vbLabel: l("header 01"),
  },

  {
    label: l("header11"),
    value: 3,
    vbLabel: l("header 02"),
  },
  {
    label: l("header12"),
    value: 4,
    vbLabel: l("header 03"),
  },
  {
    label: l("header13"),
    value: 5,
    vbLabel: l("header 04"),
  },
  {
    label: l("header1"),
    value: 6,
    vbLabel: l("header 05"),
  },
  {
    label: l("header2"),
    value: 7,
    vbLabel: l("header 06"),
  },

  {
    label: l("header6"),
    value: 8,
    vbLabel: l("header 07"),
  },
  {
    label: l("header7"),
    value: 9,
    vbLabel: l("header 08"),
  },
  {
    label: l("header8"),
    value: 10,
    vbLabel: l("header 09"),
  },
  {
    label: l("awesome"),
    value: 11,
    vbLabel: l("Header 10"),
  },

  {
    label: l("groovebook"),
    value: 12,
    vbLabel: l("Header 11"),
  },

  {
    label: l("luxury"),
    value: 13,
    vbLabel: l("Header 12"),
  },
];

function mapStateToProps(state) {
  return {
    elementToEdit: state.rootReducer.elementToEdit || null,
    fetchedPayloads: state.rootReducer.fetchedPayloads || {},
    fetchedMenu: state.rootReducer.fetchedMenu || [],
    currentDevice: state.rootReducer.currentDevice || "xl",
    currentPage: state.rootReducer.currentPage || "home",
    appearanceSettings: state.rootReducer.appearanceSettings || {},
    header: state.rootReducer.header || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchSetting: (setting) =>
      dispatch({ type: "SET_APPEARANCE", settings: setting }),
    setHeaderData: (headerData) =>
      dispatch({ type: "SET_HEADER_DATA", header: headerData }),
  };
}

export class HeaderSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleName: "",
      styleVaule: null,
      header_link_color: null,
      header_background_color: null,
      showSearch: null,
      showLogin: null,
      cartIcon: "",
      headerOptions: headerLabelMap.map((item, index) => {
        return {
          label: capitalize(item.vbLabel),
          value: item.value,
          boValue: item.label,
        };
      }),
    };
  }

  componentDidMount() {
    this._setSettings();
    this._getCartIcon();
  }

  _getCartIcon = () => {
    axios
      .post(ajaxUri, {
        request: "getCartIcon",
      })
      .then((res) => {
        if (res.data["url"]) {
          this.setState({ cartIcon: res.data["url"] });
        }
      })
      .catch((err) => console.log(err));
  };

  _setType() {
    const {
      showSearch,
      showLogin,
      header_background_color,
      header_link_color,
      styleName: name,
    } = this.state;

    let value = 0;

    this.state.headerOptions.forEach((item, index) => {
      if (item.boValue == name) {
        value = item.value;
      }
    });

    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "updateHeaderFooterType",
        element: "header",
        type: name,
        demo: false,
        setting: JSON.stringify({
          showSearch: showSearch,
          showLogin: showLogin,
          background: header_background_color,
          linkColor: header_link_color,
        }),
      },
    })
      .then((result) => {
        if (result.data.status === "success") {
          const html = result.data.html;
          this.setState(
            {
              styleVaule: value,
              styleName: name,
              headerOptions: headerLabelMap.map((item, index) => {
                return {
                  label: capitalize(item.vbLabel),
                  value: item.value,
                  boValue: item.label,
                };
              }),
            },
            () => {
              this.props.setHeaderData({
                ...this.props.header,
                type: name || "default",
                html,
                value: value,
              });
            }
          );
        }
        // this.props.reload();
        GKEvent.notification(
          result.data.status,
          `Header is updated to ${this.state.headerOptions[value - 1].label}`
        );
      })
      .catch((error) => {
        console.error("Error ajax");
      });
  }

  _onStyleChange = (value) => {
    let type = "default";
    if (this.state.styleVaule == value) {
      return;
    }
    this.state.headerOptions.forEach((item, index) => {
      if (item.value == value) {
        type = item.boValue;
      }
    });

    this.setState({
      styleVaule: value,
      styleName: type,
      headerOptions: headerLabelMap.map((item, index) => {
        return {
          label: capitalize(item.vbLabel),
          value: item.value,
          boValue: item.label,
        };
      }),
    });
  };

  _changeSetting = (key, val) => {
    if (key === "header_link_font") {
      // do nothing
      return;
    } else {
      this.setState({ [key]: val }, () => {
        this.props.dispatchSetting({
          ...this.props.appearanceSettings,
          ...this.state,
        });
      });
    }
  };

  _setSettings = () => {
    let headerValue = null;
    let headers = [...headerLabelMap];
    const { type } = this.props.header || {};
    const {
      header_background_color = "#fff",
      header_link_color = "#000",
      showSearch = true,
      showLogin = true,
    } = this.props.appearanceSettings;

    headers.map(({ label, value }) => {
      if (label == type) {
        headerValue = value;
      }
    });

    if (!headerValue) {
      const header = tempHeader.filter((item, index) => item.label === type);

      if (header.length > 0) {
        headers = [...headers, header[0]];
        headerValue = header[0]?.value;
      }
    }

    this.setState({
      header_background_color: header_background_color || "#fff",
      header_link_color: header_link_color || "#000",
      showLogin: showLogin ?? true,
      showSearch: showSearch ?? true,
      styleName: type,
      styleVaule: headerValue,
      headerOptions: headers.map((item, index) => {
        return {
          label: capitalize(item.vbLabel),
          value: item.value,
          boValue: item.label,
        };
      }),
    });
  };

  _saveSettings = () => {
    const state = { ...this.state, headerOptions: "" };
    if (window.location.href.includes("devgk")) {
      // console.log("state -> ", state);
      // console.log("appearance -> ", this.props.appearanceSettings);
    }
    axios
      .post(ajaxUri, {
        request: "setAppearanceSetting",
        settings: JSON.stringify({
          ...this.props.appearanceSettings,
          ...state,
        }),
      })
      .then((response) => {
        {
          GKEvent.notification("success", "Header Settings updated");
          this.props.dispatchSetting({
            ...this.props.appearanceSettings,
            ...this.state,
          });
          this._setType();
          // fetchAppearanceSettings();
        }
      })
      .catch((err) => {
        console.log(err);
        GKEvent.notification("error", "Something is wrong");
      });
  };

  _updateCartIcon = (url) => {
    const settings = this.state;
    axios
      .post(ajaxUri, {
        request: "updateCartIcon",
        element: "header",
        settigns: JSON.stringify(settings),
        url: url,
      })
      .then((res) => {
        GKEvent.notification("success", "Cart Icon Updated");
      })
      .catch((err) => {
        console.log(err);
        GKEvent.notification("error", "Something is wrong");
      });
  };

  render() {
    return (
      <div className="theme-setting-block">
        <div className="appearance-head">
          <button
            className="new-item"
            onClick={() => {
              this._saveSettings();
            }}
          >
            <Icon icon="check" />
          </button>
        </div>
        <div className="body">
          <div
            style={{
              marginBottom: 20,
            }}
          >
            <div className="section" style={{ marginTop: 20 }}>
              <label className="small" style={{ marginBottom: 15 }}>
                <strong>{l("Style")}</strong>
              </label>
              <Select
                value={this.state.styleVaule || 0}
                onChange={(value) => {
                  this._onStyleChange(value);
                }}
                options={this.state.headerOptions}
                dark
                placeholder={"Choose Header"}
              />
            </div>

            <div className="section">
              <label
                className="small"
                style={{ marginTop: 15, marginBottom: 8 }}
              >
                <strong>{l("Colors")}</strong>
              </label>
            </div>
            <div className="section color">
              <label
                className="small"
                style={{ marginTop: 8, marginBottom: 8 }}
              >
                {" "}
                {l("Header")}{" "}
              </label>
              <ColorSetter
                color={this.state.header_background_color || "#000"}
                onChangeComplete={(val) => {
                  this._changeSetting("header_background_color", val);
                }}
                right
              />
            </div>
            <div className="section color">
              <label
                className="small"
                style={{ marginTop: 8, marginBottom: 8 }}
              >
                {" "}
                {l("Links")}{" "}
              </label>
              <ColorSetter
                color={this.state.header_link_color || "#000"}
                onChangeComplete={(val) => {
                  this._changeSetting("header_link_color", val);
                }}
                right
              />
            </div>

            <div className="section color">
              <label
                className="small"
                style={{ marginTop: 8, marginBottom: 8 }}
              >
                {" "}
                {l("Show Search")}{" "}
              </label>
              <Switch
                checked={this.state.showSearch}
                onChange={(e) => {
                  this._changeSetting("showSearch", e.target.checked);
                }}
              />
            </div>
            <div className="section color">
              <label
                className="small"
                style={{ marginTop: 8, marginBottom: 8 }}
              >
                {" "}
                {l("Show Login")}{" "}
              </label>
              <Switch
                checked={this.state.showLogin}
                onChange={(e) => {
                  this._changeSetting("showLogin", e.target.checked);
                }}
              />
            </div>

            <p className="alert-cart-icon">
              Please use PNG image to have a logo with transparent background
            </p>
            <div className="section">
              <ImageUploader
                title={l("Cart Icon")}
                withIcon={true}
                buttonText={l("Upload Icon")}
                onChange={(url) => {
                  this._updateCartIcon(url);
                }}
                imgExtension={[".gif", ".png", ".webp", "svg"]}
                maxFileSize={5242880}
                withPreview={true}
                defaultImages={this.state.cartIcon}
                cartIcon
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderSetting);
